import React, { ChangeEvent, KeyboardEvent, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import * as Styled from 'shiftNotes/styles/NotesStack.style';

interface SubmitStepProps {
  overallComment: string;
  onOverallCommentChange: (comment: string) => void;
  disabled?: boolean;
  description?: string;
  placeholder?: string;
}

export default function SubmitStep({
  overallComment,
  onOverallCommentChange,
  disabled = false,
  description,
  placeholder,
}: SubmitStepProps): JSX.Element {
  const { t } = useTranslation('pageShiftNotes');

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    onOverallCommentChange(event.target.value);
  };

  const resolvedPlaceholder =
    placeholder ?? t('reflexFeedback.overallPlaceholder');

  return (
    <>
      {description && (
        <Styled.EmptyReflexDescription>
          {description}
        </Styled.EmptyReflexDescription>
      )}
      <Styled.TextArea
        value={overallComment}
        onChange={handleChange}
        onClick={(event: MouseEvent) => event.stopPropagation()}
        onKeyDown={(event: KeyboardEvent) => event.stopPropagation()}
        placeholder={resolvedPlaceholder}
        aria-label={resolvedPlaceholder}
        disabled={disabled}
      />
    </>
  );
}
